/**
 * Safely extracts error message from API responses
 * Handles Pydantic validation errors which return objects instead of strings
 */
export const getErrorMessage = (error, fallback = 'An error occurred') => {
  const detail = error?.response?.data?.detail;
  
  if (!detail) {
    return error?.message || fallback;
  }
  
  // If detail is a string, return it directly
  if (typeof detail === 'string') {
    return detail;
  }
  
  // If detail is an array (Pydantic validation errors)
  if (Array.isArray(detail)) {
    // Extract the 'msg' field from each error and join them
    const messages = detail
      .map(err => err.msg || err.message || JSON.stringify(err))
      .filter(Boolean);
    return messages.length > 0 ? messages.join(', ') : fallback;
  }
  
  // If detail is an object with 'msg' field
  if (typeof detail === 'object' && detail.msg) {
    return detail.msg;
  }
  
  // Fallback: try to stringify the object
  try {
    return JSON.stringify(detail);
  } catch {
    return fallback;
  }
};

export default getErrorMessage;
